import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {ReactSVG} from 'react-svg';

import classNames from 'classnames';

import {logo, logo2, phone} from '../../assets';
import {ContactsModal} from '../../components';
import {MENU_ITEMS} from '../../const';
import {MenuItem} from '../../types';

import './style.scss';

const Home = () => {
	const [isOpenContacts, setIsOpenContacts] = useState(false);

	const getShape = (type: number) => {
		const itemData: MenuItem | undefined = MENU_ITEMS.find(item => item.type === type);
		if (itemData) {
			return (
				<div className={`shape shape${itemData.type}`}>
					<NavLink to={`/general#t${itemData.type}`}>
						<div className="button">
							<div className="hex">
								<div />
								<div>
									<article className="text-box">
										<ReactSVG
											src={itemData.icon}
											className="text-box__icon"
											alt="nav-icon"
											wrapper="span"
											style={{
												width: `${itemData.type === 3 ? '65px' : '60px'}`,
												marginBottom: '10px',
											}}
										/>
										<span className="text-box__text">{itemData.label}</span>
									</article>
								</div>
								<div />
							</div>
							<div className="hex">
								<div />
								<div />
								<div />
							</div>
						</div>
					</NavLink>
				</div>
			);
		}
		return false;
	};

	const getRectangleMenu = MENU_ITEMS.map(item => {
		return (
			<NavLink to={`/general#t${item.type}`} key={item.label}>
				<div className={`rectangle-nav-item t${item.type} icon`}>
					<ReactSVG
						src={item.icon}
						wrapper="div"
						className="rectangle-nav-item__icon"
						alt="nav-icon"
					/>
					<span className="rectangle-nav-item__text">{item.label}</span>
				</div>
			</NavLink>
		);
	});

	return (
		<div className={classNames('home', {noScroll: isOpenContacts})}>
			<div className="rectangle-wrapper">
				<div className="logo-item icon">
					<div className="rectangle-nav-item__logo">
						<NavLink to="/general">
							<ReactSVG src={logo2} alt="Logo" className="rectangle-nav-item__icon" />
						</NavLink>
					</div>
					<div className="rectangle-nav-item__text">
						Транспортно-логистическая комания ДиСав
					</div>
					<button
						className="rectangle-nav-item__contacts"
						onClick={() => setIsOpenContacts(!isOpenContacts)}
						type="button">
						<ReactSVG src={phone} alt="logo_phone" className="logo_phone" />
					</button>
				</div>
				{getRectangleMenu}
			</div>
			<div className="shapes-wrapper">
				<div className="row row1">
					{getShape(1)}
					{getShape(2)}
				</div>
				<div className="row row2">
					{getShape(6)}
					<div className="shape shapeLogo">
						<NavLink to="/general">
							<div className="button">
								<div className="hex">
									<div />
									<div>
										<article className="text-box">
											<ReactSVG
												src={logo}
												alt="Logo"
												wrapper="span"
												className="text-box__icon logo"
											/>
										</article>
									</div>
									<div />
								</div>
								<div className="hex">
									<div />
									<div />
									<div />
								</div>
							</div>
						</NavLink>
					</div>
					{getShape(3)}
				</div>
				<div className="row row3">
					{getShape(5)}
					{getShape(4)}
				</div>
			</div>
			<div className="row-description">
				<h1>
					<span>Предлагаем полный</span> <span>комплекс</span>{' '}
					<span>транспортно-логистических</span> <span>услуг по доставке</span>{' '}
					<span>железной дорогой</span> <span>вашей продукции.</span>
				</h1>
			</div>
			{/* className="home-contactsModal" */}
			<ContactsModal isOpenContacts={isOpenContacts} className="home-contactsModal" />
		</div>
	);
};

export default Home;
